module.exports = __webpack_public_path__ + "static/media/paginate-left-arrow.9d72461b.svg";